// Real Student Data from St Patrick's College
// All 343 students across 13 classes
// Ready for teachers to upload curriculum documents for each class

// Year 7 A - 26 students
export const year7aStudents = [
  "Meliana Anga",
  "Trisha Aranhambath",
  "Esmerilda Aru",
  "Briano Aru",
  "Lillian Aru",
  "Valdonic Aru",
  "Briana Bakae",
  "Pautine Bata",
  "Ryan Boe",
  "Kasidy Boe",
  "Esmerilda David",
  "Trish Dovo",
  "Damien Huri",
  "Vivian Kieth",
  "Ini Selwyn",
  "Benjamin Tabi",
  "Jackson Tagaro",
  "Malia Tamata",
  "Gaylonia Tari",
  "Irene Tari",
  "Dalsino Tari",
  "Merima Tari",
  "Delisha Tari",
  "Scorefield Tari",
  "Hamish Tariqutu",
  "Donaela Toa",
];

// Year 7 B - 25 students
export const year7bStudents = [
  "Jamina Aru",
  "Lynstel Ala",
  "Ashilia Aru",
  "Joyline Boe",
  "Bradley Dudu R",
  "Nelson Garae",
  "Brienly Haga",
  "Jefta Hangoleo",
  "Mereline Leona",
  "Marina Mala",
  "Pedro Miller",
  "Megen Mwera",
  "Ryan Ngari",
  "Julinda Ngwele",
  "Kieth Nike",
  "Melrina Sike",
  "Masia Taga",
  "Yano Tambe",
  "Andrea Tari",
  "Rialdo Tari",
  "Jayden Tari Lalau",
  "Nelisha Tavoa",
  "Lelanie Ute",
  "Merion Visai",
  "Christy Vuhu",
];

// Year 8 - 51 students
export const year8Students = [
  "Markris Aru",
  "Marvin Banga",
  "Bianca Bani",
  "Orolia Bani",
  "Victoria Bata",
  "Joseph Bata",
  "Wilkins Boe",
  "Kathleen Butu",
  "Lilyn Emon",
  "Tashiana Gama Q",
  "Dorina Garae",
  "Junino Garae",
  "Briano Garae",
  "Jayvien Garae",
  "Walter Hinge",
  "Johnsen Jack",
  "Litiana Loli",
  "Selina Mala",
  "Nicholas Mera",
  "Jerina Mera",
  "Trevison Mera",
  "Joel Moli Aru",
  "Jayven Mwera",
  "Kalisha Mwera",
  "Shiliana Mwerakali",
  "George Nako",
  "Alice Natnaur",
  "Aiden Nwolgen",
  "Iennly Qwara",
  "Rotrien Qwara",
  "Patricia Rasu",
  "Shania Rihai",
  "Jentian Tari",
  "Marian Tari",
  "Selina Tari",
  "Rodrick Tari",
  "Lonixly Tari",
  "Janesa Tari",
  "Alice Tari",
  "Nester Tari",
  "Gino Tavoa",
  "Lavenda Toa",
  "Jenelyn Tonny",
  "Sophia Vina",
  "Gresilla Visai",
  "Ryan Vuti",
  "Meliana Vuti",
  "Rightly Wai",
  "Lency Wemback",
  "Amanda Woi",
  "Magustina Vanua",
];

// Year 9 - Placeholder (awaiting student list from school)
export const year9Students = [
  // Add Year 9 student names here when available
];

// Year 10 - 36 students
export const year10Students = [
  "Rensly Aru",
  "Jasly Aru",
  "Alex Arumwele",
  "Casaly Bani",
  "Sten Boe",
  "Larisha Boe",
  "Danlee Bue",
  "Chris Butu",
  "Jefflyn Gama",
  "Jandriona Garae",
  "Julie Garae",
  "Chelsie Garae",
  "Lavinia Haga",
  "Jeanvian Leo",
  "Alicia Melep",
  "Jayliven Mera",
  "Adeline Muhango",
  "Nelson Nako",
  "Junnie Qwai",
  "Harry Rongo",
  "Jesselyn Sale",
  "Walter Still",
  "Salaimona Still",
  "Dyren Tabi Kyna",
  "Tristan Tafau",
  "Damien Tari",
  "Selestina Tari",
  "Merion Tari",
  "Lawence Tari",
  "Riano Tari",
  "Nelson Tariviroviro",
  "Jessie Toa",
  "Clarisa Tore",
  "Rickson Tungu",
  "Amelia Vuhu",
  "Lavina Waieng",
];

// Year 11 A - 26 students
export const year11aStudents = [
  "Johnny Aru",
  "Angelica Boe",
  "Tanisha Boeliu",
  "Abraham Bovu",
  "Jeremaiah Edgar",
  "Hellen Garu",
  "Deshila Gelesi",
  "Mahana Huri",
  "Nancy James",
  "Elvina Lama",
  "Shalinda Leo",
  "Madlen Livuduru",
  "Alira Ngwerokava",
  "Barnabas Quai Kokona",
  "Shamina Salelingleo",
  "Lila Siro",
  "Markton Tabi",
  "Danson Taga",
  "Magreth Tari",
  "Kimberlyn Tari",
  "Herena Tavoa",
  "Jaydiro Tokale",
  "Vince Virataitai",
  "Anderson Viratokari",
  "Chrishila Vuti",
  "Kefrina Vutinaboe",
];

// Year 11 C - 16 students
export const year11cStudents = [
  "Olive Hangoleo",
  "Joana Banga",
  "Hingeana Hinge",
  "Serah Lui",
  "Handiana Mala",
  "Deven Mera",
  "Michela Ngwele",
  "Edith Sine Rees",
  "Ethrian Takaro",
  "Tristano Tari",
  "Jenria Tari",
  "Kingsley Tole",
  "Terrence Uli Maulingi",
  "Ladona Wai",
  "Fellina Weman",
  "Jeanick Woivire",
];

// Year 11 S - 34 students
export const year11sStudents = [
  "Jelis Adin",
  "Swanson Adin",
  "Nicholas Aka",
  "Nessalyn Aru",
  "Baptiste Bague",
  "Gabriel Banga",
  "Verolyn Bule",
  "Sherin Bule Sigo",
  "Osdale Peter Doro",
  "Sima Dule",
  "Nesia Garae",
  "Erima Garae",
  "Anna Garae",
  "Viandrah Garae S",
  "Iven Gete",
  "Evana Gigina",
  "Alicia Hazell",
  "Chris Hinge",
  "Bensly Leo",
  "Diana Ngwele",
  "Shirley Rasu Joy",
  "Obedinco Sau",
  "Samuel Sese",
  "Eslyn Tabi",
  "Loen Tamata",
  "Jocolyn Tari",
  "Rowan Tariveve",
  "Yazidevara Tarivoli",
  "Ephraim Tigona",
  "Mathias Toa",
  "Vince Tugu",
  "Angela Ure",
  "Aslina Virekave",
  "Pierez Vusilai",
];

// Year 12 A - 27 students
export const year12aStudents = [
  "Dailyn Allan",
  "Rexley Amos",
  "Lydiano Aru",
  "Jasmina Binihi",
  "Milton Boe",
  "Shamina Carro",
  "Kelisha Garae",
  "Tiffany Garae",
  "Shanalyn Garoleo",
  "Reman Gatava B",
  "Alice Leo",
  "Kadasha Linvanua",
  "Jaylina Mwera",
  "Norolyn Natu",
  "Deslyn Sale",
  "Tresilla Sale",
  "Romani Siehi",
  "Mahana Tagaro",
  "Jenista Tari",
  "Aneth Tari",
  "Madlen Tari",
  "Rickson Tari",
  "Fiona Tari Woi",
  "Gabriel Tariwalek",
  "Mayline Tukunamoli",
  "Nickaela Viro",
  "Rodrick Watoh",
];

// Year 12 C - 34 students
export const year12cStudents = [
  "Ansly Aru",
  "Trisha Aru",
  "Jacklyn Aru",
  "Elington Aru",
  "Jaswina Aru",
  "Astine Baet",
  "Clairiza Balmasen",
  "Frisan Bolenga",
  "Serah Bovu",
  "Yonel David",
  "Clement Garae",
  "Junilyne Garaevuhu",
  "Jayson Garoleo",
  "Alisha Haga",
  "Mickelson Ishmael",
  "Jenkins Lulu Ray",
  "Fernado Mala",
  "Tommy Rihai",
  "Matlinda Ruru",
  "Jameson Sale",
  "Gina Selwyn",
  "Gehasie Sigi",
  "Denny Somwia",
  "Jaylyn Sylvian",
  "Jessie Tahi Mark",
  "Terry Takaro",
  "Mackenly Tari",
  "Shamina Tari",
  "Rosemary Tarisesei",
  "Lorenzo Tavoa",
  "Fiona Toa",
  "Viona Tuku",
  "Joston Ute",
  "Evana Vuti",
];

// Year 12 S - 29 students
export const year12sStudents = [
  "Ineth Boe Rose",
  "Becky Aris",
  "Toares Arsenal",
  "Ashianti Baet",
  "Edino Banga",
  "Tressia Boe",
  "Nancy Bule",
  "Saniela Butu",
  "Jefly Garae",
  "Joshua Garae",
  "Kayson Garae",
  "Kefrina Garoleo",
  "Daian Ishmael",
  "Melancha Leo",
  "Alishia Lili",
  "Casandra Metmetsan",
  "Zetrick Pantutun",
  "Judy Sine",
  "Tatangni Siro Daniel",
  "Magaret Tambe",
  "Loana Tari",
  "Zedrack Tari",
  "Kaysie Tari",
  "Patrisha Tavoa",
  "Paul Tavoa",
  "Shamilla Unina",
  "Abel Vira",
  "Lindy Wekal",
  "Irene Weman",
];

// Year 13 A - 15 students
export const year13aStudents = [
  "Cathlyn Arubospey",
  "Norah Asimel",
  "Selina Avock Huli",
  "Fiona Bebe",
  "Rizna Elman",
  "Christopher Elton W",
  "Hellency Garae",
  "Liunes Hinge",
  "Stevan Kakalis Ben",
  "Anson Kenenth",
  "Trishia Reveboe",
  "Melanie Tasso",
  "Vaina Tete",
  "Florence Vavak",
  "Jeaneth Vendamy",
];

// Year 13 Computer Studies - 5 students
export const year13ComputerStudiesStudents = [
  "Jeck Aptaure",
  "Talina Lolan Bani",
  "Jeanly Bawi",
  "Evelyn Tari",
  "Juliana Tema",
];

// Year 13 S - 19 students
export const year13sStudents = [
  "Daniel Bani",
  "Daison Bovu",
  "Daniel Bue",
  "Julie Bwasi",
  "Emylyn Dimala",
  "Darren Metriag",
  "Rennie Moliuriuri",
  "Jessie Ori",
  "John Raph Mark",
  "Sorinson Ray",
  "Rasel Sevio",
  "Joylin Still",
  "Lamona Still",
  "Julio Tambe",
  "Orsahy Tari",
  "Ashileen Tari",
  "Brenton Tari",
  "Mercy Tarileo G",
  "Janet Toa",
];

// Get students for a specific class
export const getStudentsForClass = (classTitle) => {
  // Year 7
  if (classTitle.includes("Year 7A") || classTitle.includes("Year 7 A")) {
    return year7aStudents.map((name, i) => ({ id: `7a-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 7B") || classTitle.includes("Year 7 B")) {
    return year7bStudents.map((name, i) => ({ id: `7b-${i}`, name, status: 'present' }));
  }
  
  // Year 8
  if (classTitle.includes("Year 8")) {
    return year8Students.map((name, i) => ({ id: `8-${i}`, name, status: 'present' }));
  }
  
  // Year 10
  if (classTitle.includes("Year 10")) {
    return year10Students.map((name, i) => ({ id: `10-${i}`, name, status: 'present' }));
  }
  
  // Year 11
  if (classTitle.includes("Year 11A") || classTitle.includes("Year 11 A")) {
    return year11aStudents.map((name, i) => ({ id: `11a-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 11C") || classTitle.includes("Year 11 C")) {
    return year11cStudents.map((name, i) => ({ id: `11c-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 11S") || classTitle.includes("Year 11 S")) {
    return year11sStudents.map((name, i) => ({ id: `11s-${i}`, name, status: 'present' }));
  }
  
  // Year 12
  if (classTitle.includes("Year 12A") || classTitle.includes("Year 12 A")) {
    return year12aStudents.map((name, i) => ({ id: `12a-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 12C") || classTitle.includes("Year 12 C")) {
    return year12cStudents.map((name, i) => ({ id: `12c-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 12S") || classTitle.includes("Year 12 S")) {
    return year12sStudents.map((name, i) => ({ id: `12s-${i}`, name, status: 'present' }));
  }
  
  // Year 13
  if (classTitle.includes("Year 13A") || classTitle.includes("Year 13 A")) {
    return year13aStudents.map((name, i) => ({ id: `13a-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 13") && classTitle.includes("Computer")) {
    return year13ComputerStudiesStudents.map((name, i) => ({ id: `13cs-${i}`, name, status: 'present' }));
  }
  if (classTitle.includes("Year 13S") || classTitle.includes("Year 13 S")) {
    return year13sStudents.map((name, i) => ({ id: `13s-${i}`, name, status: 'present' }));
  }
  
  // Default: return empty array for unmatched classes
  return [];
};
